<div class="page-layout">
  <section class="section-wrapper">
    <h2 class="cam-heading">
      {{headerContent?.['b2b.header.familymembermanagement'] || 'Family Member Management'}}
      <!-- {{title}} -->
    </h2>
    <div class="f-col main-content">

      <mat-tab-group animationDuration="0ms" class="booking-content tab-group-mx-0 custom-mat-handler" [selectedIndex]="selectedTabIndex" (selectedTabChange)="onTabChange($event)">
        <ng-container *ngFor="let tablable of tabLabels">
          <mat-tab [label]="tablable"></mat-tab>
        </ng-container>
      </mat-tab-group>

      <div class="styleguide-layout-tabs-tab">
        <div class="f-row filter-row custom-filter-container responsive-mob">
          <div class="component-search">
            <input placeholder="Search by employee code, employee name and email address" name="search"
              (input)="searchFilter($event)">
            <span class="f-row">
              <mat-icon fontSet="material-symbols-outlined" class="search-icon"> search </mat-icon>
            </span>
          </div>

          <div class="sorting">
            <mat-form-field class="selection-filter">
              <button type="button" class="button-as-span mat-label" (click)="sortBy()">{{manageTravelerContent?.['b2b.managetraveler.sortby'] || 'Sort by:'}}</button>
              <mat-select class="sort-flight-filter" [(value)]="selected" (selectionChange)="sortData($event.value)">
                <mat-option [value]="label.Key" *ngFor="let label of sortLabels">{{label.Phrase}}</mat-option>
              </mat-select>
              <mat-icon fontSet="material-symbols-outlined" matSuffix> swap_vert </mat-icon>
            </mat-form-field>
          </div>
        </div>

        <div class="m-top-24">
          <div class="section-table data-listing text-left">
            <table class="mat-mdc-table w-100 border-collapse border-0">
              <thead role="rowgroup" class="mat-mdc-header-row mdc-data-table__header-row cdk-header-row">
                <tr>
                  <!-- <th class="mat-mdc-header-cell" *ngFor="let head of tableHead">{{head}}</th> -->
                  <th class="mat-mdc-header-cell">{{manageTravelerContent?.['b2b.managetraveler.employcode'] || 'Employee code'}}</th>
                  <th class="mat-mdc-header-cell">{{manageTravelerContent?.['b2b.managetraveler.employname'] || 'Employee name'}}</th>
                  <th class="mat-mdc-header-cell">{{content?.['b2b.managecompany.emailaddress'] || 'Email Address'}}</th>
                  <th class="mat-mdc-header-cell">Family members name</th>
                  <th class="mat-mdc-header-cell">Email of family members</th>
                  <th class="mat-mdc-header-cell">{{manageTravelerContent?.['b2b.managetraveler.relation'] || 'Relationship'}}</th>
                  <th class="mat-mdc-header-cell">Request received on</th>
                  <th class="mat-mdc-header-cell">{{manageTravelerContent?.['b2b.managetraveler.status'] || 'Status'}}</th>
                  <th class="mat-mdc-header-cell">{{manageTravelerContent?.['b2b.managetraveler.actions'] || 'Action'}}</th>
                </tr>
              </thead>
              <tbody role="rowgroup" class="mdc-data-table__content">
                <ng-container *ngIf="filteredData.length; else noDataFound">
                  <tr class="mat-mdc-row" *ngFor="let data of paginatedData">
                    <td class="mat-mdc-cell">{{data?.employee_Code || 'NA'}}</td>
                    <td class="mat-mdc-cell" [ngClass]="{'disabled': (data.userStatus == '0') || (data.userStatus == '5')}" ><a class="onclick-cell primary-link" (click)="(data.userStatus == '0' || data.userStatus == '5')?'':viewInvite(data)">{{data?.dependantName || 'NA'}}</a></td>
                    <td class="mat-mdc-cell">{{data?.dependantEmail || 'NA'}}</td>
                    <td class="mat-mdc-cell">{{data?.employeeName || 'NA'}}</td>
                    <td class="mat-mdc-cell">{{data?.employeeEmail || 'NA'}}</td>
                    <td class="mat-mdc-cell">{{data?.relationship || 'NA'}}</td>
                    <td class="mat-mdc-cell">{{(data?.requestDate || 'NA') | date:'dd MMM yy' }}</td>
                    <td class="mat-mdc-cell">
                      <span
                      [ngClass]="`status-chip status-chip-${data.userStatus == '1'?'approved':data.userStatus == '2' || data.userStatus == '4'?'approval-pending':'rejected'}`">
                      {{data.userStatus == '4'?'Approval pending':data.userStatus == '2'?'Invite sent':data.userStatus == '1'? (content?.['b2b.managecompany.active']):(manageTravelerContent?.['b2b.managetraveler.deactivated'])}}
                    </span>
                    </td>
                    <td class="mat-mdc-cell onclick-links" *ngIf="selectedTab == 'Requests received'">
                      <a tabindex="0" role="button" class="onclick-cell success-link" [ngClass]="{'disabled': data.userStatus == '0'}" (keydown.enter)="reviewDependent(data)" (click)="reviewDependent(data)">Review</a>
                    </td>
                    <td class="mat-mdc-cell onclick-links" [ngClass]="{'disabled': (data.userStatus == '0') || (data.userStatus == '5') || (data.userStatus == '1')}"  *ngIf="selectedTab != 'Requests received'">
                      <a tabindex="0" role="button" class="onclick-cell success-link" (click)="resendInvite(data)">{{manageTravelerContent?.['b2b.managetraveler.resend'] || 'Resend'}}</a>
                      <a tabindex="0" role="button" class="onclick-cell success-link"  (click)="viewInvite(data)" >{{policyContent?.['b2b.managepolicy.view'] || 'View'}}</a>
                    </td>
                  </tr>
                </ng-container>
                <ng-template #noDataFound>
                  <tr>
                    <td [attr.colspan]="tableHead.length" class="text-center">
                      <app-cam-empty-state (myEvent)="handleEvent($event)" [width]="'384px'"
                        [heading]="'No request for dependents'" [IsShow]="false"
                        [content]="'There are currently no pending requests to add dependents made by any traveler'"
                        [navigateTo]="'/cam/saved-dependents/dependent-information-form'"
                        >
                      </app-cam-empty-state>
                    </td>
                  </tr>
                </ng-template>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="custom-pagination" *ngIf="filteredData.length >= 20">
        <button (click)="prevPage()" [disabled]="currentPage === 0">Prev</button>
      
        <span>
          Page {{ currentPage + 1 }} of {{ totalPages }}
        </span>
      
        <button (click)="nextPage()" [disabled]="(currentPage + 1) >= totalPages">Next</button>
      </div>
      <hr class="m-top-24" />
      <div class="inner-action action-listing">
        <button mat-button class="button--primary-small" (click)="openModal(addDependentModel)">{{manageTravelerContent?.['b2b.managetraveler.addnewdependent'] || 'Add dependents'}}</button>
      </div>
    </div>
  </section>
</div>


<!-- <button mat-button class="button--primary-small" (click)="open()">Booking</button> -->

<ng-template #addDependentModel>
  <div class="custom-popup-gen-container">
    <div class="custom-popup-gen-header">
      <span>Select the employee to add a dependent</span>
      <mat-icon fontSet="material-symbols-outlined" tabindex="0" role="button" aria-label="close button" (keydown.enter)="closeModal()" (keyup.space)="closeModal()" class="close_icon" (click)="closeModal()">close</mat-icon>
    </div>
    <div class="custom-popup-gen-body">
      <div class="component-search">
        <input placeholder="Search and select employee" name="search" (input)="searchTravelerFilter($event)" />
        <span class="f-row">
          <mat-icon fontSet="material-symbols-outlined" class="search-icon"> search </mat-icon>
        </span>
      </div>
      <div class="search-list-box custom-scroll" tabindex="0">
        <!-- ✅ Check if any data exists -->
        <ng-container *ngIf="hasData(); else emptyState">
      
          <ng-container *ngFor="let group of filteredGroups | keyvalue">
            <div class="category-header">{{ group.key }}</div>
      
            <ul class="search-list">
              <li class="list"
                  *ngFor="let person of group.value"
                  (click)="addDependentFor(person)"
                  (keydown.enter)="addDependentFor(person)">
                <h4 class="name">{{ person.userName }}</h4>
                <p class="email">{{ person.emailAddress }}</p>
                <p class="emp-id">{{ person.employeeCode }}</p>
              </li>
            </ul>
      
          </ng-container>
      
        </ng-container>
      
        <!-- ✅ Global Empty State -->
        <ng-template #emptyState>
          <app-cam-empty-state 
            [heading]="policyContent?.['b2b.managepolicy.noresult'] || 'No results found'"
            [IsShow]="false"
            [content]="'We couldn\'t find what you searched for.'">
          </app-cam-empty-state>
        </ng-template>
    </div>
  </div>
  </div>
</ng-template>